 <template>
  <div>
    <v-card height="428px" flat>
      <div style="overflow: auto; max-height: 375px">
        <v-data-table
          class="fs-table-alertas"
          :loading="loading"
          no-data-text=""
          :headers="headers"
          :items="alertas"
          item-key="id"
          hide-default-footer
          :sort-desc="sortDesc"
          sort-by="id"
          hide-action
        >
          <template v-slot:body="{ items }">
            <td id="fs-pedidos-row" colspan="10" style="text-align: center" class="pt-2" v-if="alertas.length === 0 && !loading">
              Não há alertas para o pedido selecionado...
            </td>
            <tr id="fs-alertas-row" v-for="(item, index) in items" :key="index">
              <td @click="selectRow(item)">{{ item.id }}</td>
              <td @click="selectRow(item)">{{ formatarUsuario(item.usuario_id) }}</td>
              <td @click="selectRow(item)">{{ item.titulo }}</td>
              <!-- <td @click="selectRow(item)">{{ item }}</td> -->
              <td @click="selectRow(item)">{{ formatarDataHora(item.updated_at, 'L LT') }}</td>
              <!-- <td>{{ item.pendente === 'N' ? 'Não' : 'Sim' }}</td> -->
              <td width="120px" style="text-align: center">
                <v-icon class="fs-table-icons mr-2" @click="abrirNotificacoes(item)">mdi-calendar</v-icon>
                <v-icon v-if="acesso_agendamentos.editar" class="fs-table-icons mr-1" @click="editarAlerta(item)">mdi-pencil</v-icon>
                <v-icon v-if="acesso_agendamentos.excluir" class="fs-table-icons" @click="deleteAlerta(item)">mdi-delete</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <v-card-actions class="mt-3" style="padding: 0px; position: absolute; bottom: 0; right: 0">
        <v-spacer></v-spacer>
        <v-btn color="#2A2F50" @click="adicionarAlerta()" dark small>
          <v-icon class="mr-1" style="font-size: 15px !important">mdi-bell-outline</v-icon>
          Adicionar Alerta
        </v-btn>
        <v-btn color="warning" @click="fechar()" dark small>
          <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- DIALOG ADD ALERTA -->
    <v-dialog v-model="dialog" max-width="700px" persistent>
      <v-card class="pa-3 pt-5" flat>
        <h3 class="ml-3">
          <span v-if="!alertaEditMode">Adicionar Alerta ao Pedido</span>
          <span v-else>Editar Alerta</span>
        </h3>
        <v-divider style="margin: 17px 0px 17px 0px"></v-divider>
        <v-form autocomplete="off">
          <v-row no-gutters cols="12">
            <v-col class="px-1" xs="12" md="6">
              <v-select
                :items="vendedores"
                v-model="alertaUsuarioId"
                item-text="nome"
                item-value="id"
                label="Usuário *"
                placeholder=" "
                height="32px"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col class="px-1" xs="12" md="6">
              <v-text-field
                label="Título *"
                v-model="titulo"
                placeholder=" "
                outlined
                dense
              />
            </v-col>
            <!-- DATA -->
            <v-col v-if="!alertaEditMode" class="px-1" xs="12" md="6">
              <v-menu
                v-model="popUpData1"
                :close-on-content-click="false"
                :nudge-top="48"
                :nudge-right="10"
                transition="scale-transition"
                max-width="290"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateFieldFormated"
                    append-outer-icon="mdi-calendar"
                    label="Data *"
                    placeholder=" "
                    @click:clear="data = null"
                    v-on="on"
                    outlined
                    readonly
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="data"
                  @change="popUpData1 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!-- HORA -->
            <v-col v-if="!alertaEditMode" class="px-1" xs="12" md="6">
              <v-menu
                ref="menu"
                v-model="popUpHora1"
                :close-on-content-click="false"
                transition="scale-transition"
                :return-value.sync="hora"
                :nudge-top="48"
                :nudge-right="10"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="hora"
                    label="Hora *"
                    placeholder=" "
                    append-outer-icon="mdi-calendar-clock"
                    v-on="on"
                    outlined
                    readonly
                    dense
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="popUpHora1"
                  v-model="hora"
                  full-width
                  @click:minute="$refs.menu.save(hora)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col class="px-1">
              <v-textarea
                label="Descrição *"
                placeholder=" "
                rows="4"
                spellcheck="false"
                v-model="descricao"
                outlined
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
        <v-divider style="margin: 12px 0px 12px 0px"></v-divider>
        <v-card-actions style="padding: 0px">
          <v-spacer></v-spacer>
          <v-btn color="#2A2F50" @click="saveAlerta()" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-content-save</v-icon>
            Salvar
          </v-btn>
          <v-btn color="warning" @click="dialog = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG DESCRICAO DO ALERTA -->
    <v-dialog v-model="dialogDescricao" max-width="500px">
      <v-card flat>
        <v-card-title>
          Descrição do Alerta
        </v-card-title>
        <v-card-text>
          {{ alertaSelecionado.descricao }}
        </v-card-text>
        <v-divider style="margin: 5px 12px 5px 12px"></v-divider>
        <v-card-actions class="px-3 pb-3">
          <v-spacer></v-spacer>
          <v-btn color="warning" @click="dialogDescricao = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG AGENDAMENTO DE NOTIFICACOES -->
    <v-dialog v-model="dialogAgendamento" max-width="700px" persistent>
      <v-card flat>
        <h3 class="ml-5 pt-5 pb-3">
          Agendamentos de Notificações
        </h3>
        <v-divider style="margin: 5px 12px 5px 12px"></v-divider>
        <v-row class="mx-2 mt-6" no-gutters>
          <v-col class="px-1">
            <v-menu
              v-model="popUpData2"
              :close-on-content-click="false"
              :nudge-top="48"
              :nudge-right="10"
              transition="scale-transition"
              max-width="290"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  append-outer-icon="mdi-calendar"
                  :value="dateFieldFormated"
                  label="Data *"
                  placeholder=" "
                  @click:clear="data = null"
                  v-on="on"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="data"
                @change="popUpData2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="px-1">
            <v-menu
              ref="menu"
              v-model="popUpHora2"
              :close-on-content-click="false"
              transition="scale-transition"
              :return-value.sync="hora"
              :nudge-top="48"
              :nudge-right="10"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="hora"
                  label="Hora *"
                  placeholder=" "
                  append-outer-icon="mdi-calendar-clock"
                  v-on="on"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="popUpHora2"
                v-model="hora"
                full-width
                @click:minute="$refs.menu.save(hora)"
              ></v-time-picker>
            </v-menu>
          </v-col>
          <!-- INCLUIR NOTIFICACAO -->
          <v-col>
<!--            <v-btn class="mt-1 ml-2" color="#2A2F50" @click="saveNotificacao()" dark small>-->
<!--              <v-icon class="mr-1" style="font-size: 15px !important">mdi-checkbox-marked-circle-outline</v-icon>-->
<!--              Agendar-->
<!--            </v-btn>-->
          </v-col>
        </v-row>
        <v-card class="mx-3 mb-2" flat>
          <v-data-table
            class="fs-table-alertas"
            :loading="loading"
            loading-text="Carregando notificações, aguarde..."
            no-data-text="Não há notificações para o pedido selecionado..."
            :headers="headersNotificacoes"
            :items="notificacoes"
            item-key="id"
            hide-default-footer
            hide-action
          >
            <template v-slot:body="{ items }">
              <td id="fs-pedidos-row2" colspan="10" style="text-align: center" class="pt-2" v-if="notificacoes.length === 0 && !loading">
                Não há agendamentos para o alerta selecionado...
              </td>
              <tr id="fs-pedidos-row3" v-for="(item, index) in items" :key="index">
                <td>{{ item.id }}</td>
                <td>{{ formatarDataHoraNotificacao(item.data_notificacao, 'L') }}</td>
                <td>{{ item.horario_notificacao.substr(0, 5) }}</td>
                <td>{{ item.vista === 'N' ? 'Não' : 'Sim' }}</td>
                <td width="120px" style="text-align: center">
                  <v-icon v-if="acesso_notificacoes.excluir" @click="deletarNotificacao(item.id)" class="fs-table-icons">mdi-delete</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
        <v-card-actions class="px-3 pb-3">
          <v-spacer></v-spacer>
          <v-btn color="warning" @click="dialogAgendamento = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as alertaNotificacaoApi from '@/api/alertaNotificacao'
import * as alertaApi from '@/api/alerta'
import { list } from '@/api/crud'
import { mapState, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  props: {
    itemMostrarDetalhes: Object,
    fecharDialog: Function
  },
  data () {
    return {
      acesso_agendamentos: {
        incluir: true,
        editar: false,
        excluir: false
      },
      acesso_notificacoes: {
        incluir: true,
        editar: false,
        excluir: false
      },
      headers: [
        { text: '#', value: 'id' },
        { text: 'USUÁRIO', value: 'usuario_id' },
        { text: 'TÍTULO', value: 'titulo' },
        { text: 'ÚLTIMA ATUALIZAÇÃO', value: 'updated_at' },
        // { text: 'PENDENTE', value: 'pendente' },
        { text: 'NOTIFICAÇÕES', align: 'center', sortable: false }
      ],
      headersNotificacoes: [
        { text: '#', value: 'id' },
        { text: 'DATA', value: 'data_notificacao' },
        { text: 'HORA', value: 'horario_notificacao' },
        { text: 'VISTA', value: 'vista' },
        { text: 'EXCLUIR', align: 'center', sortable: false }
      ],
      dialogDescricao: false,
      dialogAgendamento: false,
      alertaSelecionado: [],
      alertaEditMode: false,
      alertaEditModeId: null,
      dialog: false,
      alertas: [],
      vendedores: [],
      alertaUsuarioId: null,
      notificacoes: [],
      sortDesc: true,
      descricao: 'Entrar em Contato',
      titulo: 'Alerta Padrão',
      loading: true,
      popUpData1: false,
      popUpHora1: false,
      popUpData2: false,
      popUpHora2: false,
      data: moment().add(1, 'days').format('YYYY-MM-DD'),
      hora: '08:00'
    }
  },
  computed: {
    dateFieldFormated () {
      // return this.data ? moment(this.data).utc().format('L') : ''
      return this.data ? moment(this.data).format('L') : ''
    },
    ...mapState({
      confirm: state => state.global.confirm
    })
  },
  watch: {
    // PARA LIMPAR O ARRAY TODA VEZ QUE O DIALOG FOR FECHADO
    dialogAgendamento: function (value) {
      if (!value) this.notificacoes = []
    },
    alertaEditMode: function (value) {
      if (!value) this.limparForm()
    }
  },
  async mounted () {
    moment.locale('pt-br')
    this.vendedores = await list('/admin/usuarioscrm')
    this.loadAlertas()
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    adicionarAlerta () {
      this.alertaEditMode = false
      this.dialog = true
    },
    fechar () {
      this.limparForm()
      this.fecharDialog()
    },
    formatarDataHora (data, format) {
      // https://www.it-swarm-pt.tech/pt/javascript/moment.js-utc-da-uma-data-errada/1041053066/
      // return moment(data).utc().format(format)
      return moment(data).format(format)
      // return data
    },
    formatarDataHoraNotificacao (data, format) {
      return moment(data).utc().format(format)
    },
    formatarUsuario (id) {
      const nome = this.vendedores.find(item => { return item.id === id })
      return nome ? nome.nome : ''
    },
    selectRow (alerta) {
      this.dialogDescricao = true
      this.alertaSelecionado = alerta
    },
    abrirNotificacoes (alerta) {
      // this.limparForm()
      this.loadNotificacoes(alerta.id)
      this.alertaSelecionado = alerta
      this.dialogAgendamento = true
    },
    async loadAlertas () {
      this.loading = true
      const filtro = {
        filtro: this.itemMostrarDetalhes.id,
        indices: ['ecommerce_carrinho_id']
      }
      this.alertas = await alertaApi.list(filtro, true)
      this.loading = false
    },
    async saveAlerta () {
      // VERIFICA SE ESTÁ NO MODO EDIÇÃO E FAZ O UPDATE OU O POST
      if (this.alertaUsuarioId && this.titulo && this.alertaUsuarioId && this.descricao) {
        this.dialog = false
        // UPDATE
        if (this.alertaEditMode) {
          const data = {
            usuario_id: this.alertaUsuarioId,
            titulo: this.titulo,
            descricao: this.descricao
          }
          try {
            await alertaApi.edit({}, this.alertaEditModeId, data)
            this.setSnackbar({ msg: 'Alerta atualizado com Sucesso!', color: 'green' })
            this.loadAlertas()
          } catch (error) {
            this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
          }
        } else {
          // POST
          if (this.descricao.length > 0) {
            const data = {
              ecommerce_carrinho_id: this.itemMostrarDetalhes.id,
              usuario_id: this.alertaUsuarioId,
              titulo: this.titulo,
              descricao: this.descricao
            }
            try {
              const res = await alertaApi.add({}, data)
              await alertaNotificacaoApi.add({}, { data_notificacao: this.data, horario_notificacao: this.hora, ecommerce_alerta_id: res.id })
              this.loadAlertas()
              // this.setSnackbar({ msg: 'Alerta Adicionado com Sucesso!', color: 'green' })
            } catch (error) {
              this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
            }
          } else {
            this.setSnackbar({ msg: 'Verifique os campos e tente novamente!' })
          }
        }
      } else {
        this.setSnackbar({ msg: 'Verifique os campos e tente novamente!' })
      }
    },
    async editarAlerta (item) {
      this.alertaEditModeId = item.id
      this.titulo = item.titulo
      this.alertaUsuarioId = item.usuario_id
      this.descricao = item.descricao
      this.alertaEditMode = true
      this.dialog = true
    },
    async deleteAlerta (item) {
      if (await this.confirm.open('Excluir Alerta', 'Tem certeza que deseja excluir este alerta?', { color: 'red' })) {
        try {
          await alertaApi.del({}, item.id)
          this.loadAlertas()
          this.setSnackbar({ msg: 'Alerta Excluído com Sucesso!', color: 'green' })
        } catch (error) {
          this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
        }
      }
    },
    async loadNotificacoes (id) {
      const filtro = {
        filtro: id,
        indices: ['ecommerce_alerta_id']
      }
      this.notificacoes = await alertaNotificacaoApi.list(filtro, true)
    },
    async saveNotificacao () {
      if (this.data && this.hora) {
        const aux = this.notificacoes.find(item => {
          if ((this.hora === item.horario_notificacao.slice(0, 5)) && (moment(this.data).format('L') === moment(item.data_notificacao).format('L'))) return item
        })
        if (!aux) {
          try {
            await alertaNotificacaoApi.add({}, {
              data_notificacao: this.data,
              horario_notificacao: this.hora,
              ecommerce_alerta_id: this.alertaSelecionado.id
            })
            this.loadNotificacoes(this.alertaSelecionado.id)
          } catch (error) {
            alert(error)
          }
        } else {
          this.setSnackbar({ msg: 'Não é possível inserir agendamentos duplicados!' })
        }
      } else {
        this.setSnackbar({ msg: 'Verifique os campos DATA e/ou HORA!' })
      }
    },
    async deletarNotificacao (id) {
      if (this.notificacoes.length > 1) {
        if (await this.confirm.open('Excluir Agendamento', 'Tem certeza que deseja excluir este agendamento?', { color: 'red' })) {
          try {
            await alertaNotificacaoApi.del({}, id)
            this.loadNotificacoes(this.alertaSelecionado.id)
            this.setSnackbar({ msg: 'Notificação Excluída com Sucesso!', color: 'green' })
          } catch (error) {
            this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
          }
        }
      } else {
        this.setSnackbar({ msg: 'É necessário ter pelo menos 1 agendamento no Alerta!' })
      }
    },
    limparForm () {
      this.titulo = ''
      this.usuario = null
      this.descricao = null
      this.alertaUsuarioId = null
      this.alertaEditModeId = null
      this.data = null
      this.hora = null
    }
  }
}
</script>

<style scoped>
  #fs-alertas-row {
    border-bottom: 1px solid rgba(204, 204, 204, 0.363) !important;
  }
  #fs-alertas-row:hover {
    cursor: pointer;
    background-color: rgba(204, 204, 204, 0.363) !important;
  }
  .fs-table-icons {
    padding: 3px;
  }
  .fs-table-icons:hover {
    cursor: pointer;
    color: #3F51B5;
    border-radius: 50%;
    background-color: rgb(218, 218, 218);
  }
  .fs-table-alertas {
    border: 1px solid rgb(218, 218, 218);
    border-radius: 5px;
  }
  .destaque {
    font-weight: bold;
    border-left: 5px solid red;
  }
</style>
